import { useContext, useEffect } from "react";
import ServerIsDownContext from "../context/ServerIsDownContext";
import { getVotingEndpoint } from "../api/endpoints";
import { getRandomInt } from "../utils/utils";

function VotingResultsFetcher(props) {
  const {serverIsDown, setServerIsDown} = useContext(ServerIsDownContext);

  function updateData() {
    function fetchData(url) {
      return fetch(url)
        .then((response) => response.json())
        .then((data) => {
          props.onDataFetched(data);
        })
        .catch(err => {
          console.log(err);
          setServerIsDown(true);
        });
    }
    let timer = null;
    function fetchDataPeriodically(url) {
      fetchData(url).then(() => {
        let randomDelay = 1000 + getRandomInt(2000)
        timer = setTimeout(() => fetchDataPeriodically(url), randomDelay);
      });
    }

    if (props.votingId < 0){
      let url = getVotingEndpoint();
      fetchDataPeriodically(url);
      return () => clearInterval(timer);
    } else {
      let url = getVotingEndpoint(props.votingId);
      fetchData(url);
    } 
  }

  useEffect(updateData, []);
  return null;
}

export default VotingResultsFetcher;
